import React from "react";
import Navbar from "../Navbar/Navbar";
import Bola from "../Bola";
import Professiogramma from "./Professiogramma";
import Footer from "../Footer/Footer";

export default function ProfessiogrammaHome() {
  return (
    <div>
      <Navbar />
      <Bola />
      <Professiogramma />
      <Footer />
    </div>
  );
}
